import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { useSkinAnalyzerVisibility } from '../hooks/useAnalyzerVisibility';
import { useBrand } from '../hooks/useBrand';
import { skinAnalyserMessages } from '../messages';
import { StyledTitle } from '../styled';

export const Title = () => {
  const { isEstee } = useBrand();

  const { isVariant2 } = useSkinAnalyzerVisibility();

  return (
    <StyledTitle isVariant2={isVariant2}>
      <FormattedMessage
        {...skinAnalyserMessages.skinAnalyserTitle}
        values={{ brand: isEstee ? 'Estee Lauder' : 'La Roche-Posay' }}
      />
    </StyledTitle>
  );
};
